export default function() {

    $('.js-search-toggle').on('click', function() {
        $('.js-search-input').toggleClass('active');
    });
}